var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParagraph = function SvgParagraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.516 23.057a1 1 0 0 1 1-1h26.968a1 1 0 1 1 0 2H39.859c.09.15.141.325.141.512v30.862a1 1 0 0 1-2 0V24.57c0-.187.051-.362.141-.512H26.516a1 1 0 0 1-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 11a1 1 0 0 1 1-1h58a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1zm2 1v56h56V12z",
    clipRule: "evenodd"
  })));
};
export default SvgParagraph;